export default function Footer() {
  return (
    <footer className="border-t mt-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-10 text-sm text-muted-foreground flex flex-col sm:flex-row items-center justify-between gap-4">
        <p>© {new Date().getFullYear()} Jenn Mueng. All rights reserved.</p>
        <div className="flex items-center gap-4">
          <a
            className="hover:text-foreground"
            href="https://github.com/"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          <a
            className="hover:text-foreground"
            href="https://www.linkedin.com/"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
          <a className="hover:text-foreground" href="mailto:hello@jennmueng.dev">
            Email
          </a>
        </div>
      </div>
    </footer>
  );
}
